import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-53e26025")

_pushScopeId("data-v-53e26025")
const _hoisted_1 = { class: "position-relative" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "dropdown-toggle" }, null, -1)
_popScopeId()


import {randomId} from "@/utilities/Id";

export default _defineComponent({
  props: {
    label: {type: String, required: true},
},
  setup(__props) {

const props = __props

const id = randomId();
const contentId = 'collapse' + id + '-contents'

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("a", {
      class: "btn btn-secondary btn-sm full-width d-block d-md-none collapse-button",
      href: '#'+contentId,
      "data-bs-toggle": "collapse",
      role: "button",
      "aria-expanded": "false",
      "aria-controls": contentId
    }, [
      _createTextVNode(_toDisplayString(props.label) + " ", 1),
      _hoisted_2
    ], 8, ["href"]),
    _createVNode("div", {
      class: "collapse d-flex flex-wrap",
      id: contentId
    }, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})